import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export default function AnchorLine(_ref) {
  let {
    anchorLineOrientation,
    anchorLineStroke,
    verticalAnchor,
    horizontalAnchor,
    width,
    height
  } = _ref;
  const backgroundOutline = {
    stroke: anchorLineStroke,
    strokeWidth: 2
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [anchorLineOrientation === 'horizontal' && verticalAnchor === 'start' && /*#__PURE__*/_jsx("line", {
      ...backgroundOutline,
      x1: 0,
      x2: width,
      y1: 0,
      y2: 0
    }), anchorLineOrientation === 'horizontal' && verticalAnchor === 'end' && /*#__PURE__*/_jsx("line", {
      ...backgroundOutline,
      x1: 0,
      x2: width,
      y1: height,
      y2: height
    }), anchorLineOrientation === 'vertical' && horizontalAnchor === 'start' && /*#__PURE__*/_jsx("line", {
      ...backgroundOutline,
      x1: 0,
      x2: 0,
      y1: 0,
      y2: height
    }), anchorLineOrientation === 'vertical' && horizontalAnchor === 'end' && /*#__PURE__*/_jsx("line", {
      ...backgroundOutline,
      x1: width,
      x2: width,
      y1: 0,
      y2: height
    })]
  });
}